import React from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";

import { WorldCupLinkIFrame } from ".";

export default observer(function WorldCupLinkPopup() {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);

	if (!searchParams.has("isWorldCupOpen")) {
		return null;
	}

	return (
		<div className="popup popup--full">
			<div className="popup__card popup--full__card">
				<div className="popup__header">
					<div className="popup__title">&nbsp;</div>
					<button
						id=""
						className="btn btn--square btn--square--sml btn--secondary--inverted"
						onClick={() =>
							App.state.removeFromUrlParams(
								["isWorldCupOpen"],
								true
							)
						}
					>
						<i className="u-icon u-icon--sml u-icon--close" />
					</button>
				</div>
				<div
					id="world-cup-link-popup-body"
					className="popup__body popup--full__body"
				>
					{/* TODO: CHECK IF WE NEED LOADER FOR LOADING STATISTICS DATA */}
					{/* <div id="statisticsCardLoader" className="loader loader--centered" style={{ display: 'none'}}>
                        <div className="loader--centered__countdown" style={{ display: 'none'}}></div>
                        <div className="loader__spinner loader--centered__spinner">
                            <div className="loader__spinner__wrapper">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div> */}
					<WorldCupLinkIFrame />
				</div>
			</div>
		</div>
	);
});
